import { create } from 'zustand';

export type SourceStore = {
  source: string | null;
  setSource: (sourceParam: string | null) => void;
  getState: () => { source: string | null };
};

export const useSourceStore = create<SourceStore>((set, get) => {
  const source: string | null = null;

  return {
    source,
    setSource: (source) => set(() => ({ source })),
    getState: () => ({ source: get().source }),
  };
});
